export default __webpack_public_path__ + "f49438309fab2f14d0d460149ca91c65.png";